export class RerolledEvent {
    constructor(type, value) {
        this.type = type;
        this.value = value;
    }
    ;
}
